import React, { useState } from "react";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";

const DownloadButton = ({ base64String, fileName, backgroundColor, color }) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const handleDownload = () => {
    // Convert the Base64 string to a Blob
    const byteCharacters = atob(
      base64String[0]?.fileContent || base64String?.fileContent
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Use FileSaver.js to save the Blob as a file
    saveAs(blob, fileName);
  };

  const buttonStyle = {
    backgroundColor: `${backgroundColor || "#4CAF50"}`,
    border: "none",
    color: `${color || "white"}`,
    padding: "7px 15px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "12px",
    margin: "4px 2px",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "background-color 0.3s",
    filter: isHovered ? "brightness(70%)" : "none",
  };

  if (!base64String) {
    return null;
  }
  return (
    <button
      onClick={handleDownload}
      style={buttonStyle}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
    >
      {t("buttons.downloadPdf")}
    </button>
  );
};

export default DownloadButton;
